import { useGetActiveRouteData } from "client/src/hooks/route";
import { VIEW_TYPE } from "shared/config/routeData";

export const useIsBenEx = () => {
  const activeRouteData = useGetActiveRouteData();
  const isBenEx = activeRouteData?.viewType === VIEW_TYPE.explorer;
  return isBenEx;
};
